import * as React from 'react';
import * as Classes from '../common/classes';
import { IProps, ViewIntent } from '../common/props';
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { useInverseBg } from '../theme/useInverseBg';
import { ForwardedRef } from 'react';

export interface IIconProps extends IProps, FontAwesomeIconProps {
  intent?: ViewIntent;
  /**
   * Inverzní verze - typicky používáme na tmavším pozadí.
   */
  inverse?: boolean;
}

export type IconProps = IIconProps;

const IconIn = ({
  className,
  intent,
  inverse,
  innerRef,
  ...other
}: IconProps & { innerRef?: ForwardedRef<HTMLElement> }) => {
  const parentInverse = useInverseBg(inverse);

  const icon = (
    <FontAwesomeIcon
      className={classNames(Classes.ICON, className, {
        [Classes.TYPOGRAPHY_INHERIT]: !intent || intent === 'inherit',
        [Classes.TYPOGRAPHY_PRIMARY]: intent === 'primary',
        [Classes.TYPOGRAPHY_SECONDARY]: intent === 'secondary',
        [Classes.TYPOGRAPHY_DANGER]: intent === 'danger',
        [Classes.TYPOGRAPHY_SUCCESS]: intent === 'success',
        [Classes.TYPOGRAPHY_WARNING]: intent === 'warning',
        [Classes.TYPOGRAPHY_INACTIVE]: intent === 'inactive',
        [Classes.TYPOGRAPHY_DEFAULT]: intent === 'default',
        [Classes.TYPOGRAPHY_INVERSE]: parentInverse,
      })}
      {...other}
    />
  );

  if (innerRef) {
    return <span ref={innerRef}>{icon}</span>;
  } else {
    return icon;
  }
};

export const Icon = React.forwardRef<HTMLElement, IconProps>((props, ref) => {
  return <IconIn innerRef={ref} {...props} />;
});
